module.exports = __webpack_public_path__ + "static/media/MenuIcon.e3abf872.svg";